import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export const SignInComponent = ({
  onButtonClick,
}: {
  onButtonClick: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div className='h-[100dvh] w-[100dvw] flex flex-col gap-8 items-center justify-center'>
      <h1 className='text-2xl'>{t('signInComponent.title')}</h1>
      <Button variant='primary' onClick={onButtonClick}>
        {t('signInComponent.buttonTitle')}
      </Button>
    </div>
  );
};
